import { render } from "./ctx-dog-pnts.vue?vue&type=template&id=556f9b7c&scoped=true"
import script from "./ctx-dog-pnts.vue?vue&type=script&setup=true&lang=js"
export * from "./ctx-dog-pnts.vue?vue&type=script&setup=true&lang=js"

import "./ctx-dog-pnts.vue?vue&type=style&index=0&id=556f9b7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556f9b7c"],['__file',"src/views/history/history-card/components/ctx-dog-pnts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "556f9b7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('556f9b7c', __exports__)) {
    api.reload('556f9b7c', __exports__)
  }
  
  module.hot.accept("./ctx-dog-pnts.vue?vue&type=template&id=556f9b7c&scoped=true", () => {
    api.rerender('556f9b7c', render)
  })

}


export default __exports__